import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { GameActions } from "../state/GameReducer.js";
import { frameworkActions } from "../state/FrameworkReducer.js";
import { GetGameStats } from "../util/getLog";

/**
 * @name MatchEnded
 * @class MatchEnded
 * @extends {ConnectedHTMLElement}
 */
export class MatchEnded extends ConnectedHTMLElement {
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    this.render();
  }

  registerEvents() {
    const rematch = this.querySelector("#rematch-btn");
    if (rematch) {
      rematch.addEventListener("click", (e) => {
        e.preventDefault();
        DispatchAction(GameActions.rematch);
        this.render();
      });
    }
    const reset = this.querySelector("#reset-base-btn");
    if (reset) {
      reset.addEventListener("click", (e) => {
        e.preventDefault();
        DispatchAction(frameworkActions.resetAll);
        this.render();
      });
    }
  }

  render() {
    if (this.state.currentGame !== undefined && this.state.currentGame.ended) {
      const damageState = GetGameStats(this.state);

      this.innerHTML = `
      <dialog class="modal" id="end-game-modal" ${this.state.currentGame.ended === true ? "open" : ""}>
        <div class="modal-box">
        <div>
          <h3 class="font-bold text-2xl mb-2">Stats</h3>
          ${damageState}
        </div>
          <div
            class="match-ended-container p-2 flex flex-row justify-between items-center w-full "
            id="match-ended"
          >

          </div>
          <div class="modal-action p-2 flex flex-row justify-between items-center w-full ">
            <button
              type="button"
              class="btn btn-xl btn-success flex flex-col text-neutral"
              id="rematch-btn"
            >
              <span>Rematch</span>
            </button>

            <button
              type="button"
              class="btn btn-xl flex flex-col btn-error text-neutral"
              id="reset-base-btn"
            >
              <span>Reset bases</span>
            </button>
          </div>
        </div>
      </dialog>`;
      this.registerEvents();
      return;
    }

    this.innerHTML = ``;
  }
  connectedCallback() {
    this.render();
  }

  dispatchEvent(event) {
    return false;
  }
}
